import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
} from "@/components/ui/command"

import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { Button } from "@/components/ui/button"
import { Check, ChevronsUpDown } from "lucide-react"
import { useState, useEffect } from "react"

type FilterType = {
  key: string
  name: string
}

export function FilterTypeSearch({
  filterTypeData,
  isLoading,
  onSearch,
  value,
  onChange,
}: {
  filterTypeData: FilterType[]
  isLoading: boolean
  onSearch: (query: string) => void
  value: string
  onChange: (val: string) => void
}) {
  const [open, setOpen] = useState(false)
  const [input, setInput] = useState("")

  // Fire API search when typing 3+ chars

  useEffect(() => {
    const handler = setTimeout(() => {
      if (input.length >= 3) {
        onSearch(input)
      } else {
        onSearch("")
      }
    }, 300)
    return () => clearTimeout(handler)
  }, [input, onSearch])

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-[450px] justify-between"
        >
          {value
            ? filterTypeData.find((f) => f.name === value)?.name
            : "Select type"}
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[450px] p-0">
        <Command shouldFilter={false} key={filterTypeData.map(f => f.key).join(",")}>
          <CommandInput
            placeholder="Search type..."
            value={input}
            onValueChange={setInput}
          />
          <CommandList>
            {isLoading && (
              <CommandGroup>
                <CommandItem disabled>Searching...</CommandItem>
              </CommandGroup>
            )}
            {!isLoading && (
              <>
                <CommandEmpty>No types found.</CommandEmpty>
                <CommandGroup>
                  {filterTypeData.map((ft) => (
                    <CommandItem
                      key={ft.key}
                      onSelect={() => {
                        onChange(ft.name)
                        setOpen(false)
                      }}
                    >
                      {ft.name}
                      {value === ft.name && (
                        <Check className="ml-auto h-4 w-4" />
                      )}
                    </CommandItem>
                  ))}
                </CommandGroup>
              </>
            )}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}
